var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashy","data-theme":"dark"}},[_c('Header',{attrs:{"pageInfo":_vm.pageInfo}}),_c('router-view'),(_vm.showFooter)?_c('Footer',{attrs:{"text":_vm.getFooterText()}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }